import { type PartnerAndRetailerId } from 'utils/routing/params.types'
import { type SearchApiFetchDepartmentsResponse } from 'legacy/common/utils/catalog/departments/departments.types'
import instacart from 'legacy/common/instacart'

export const fetchDepartments = async (routeParams: PartnerAndRetailerId) => {
  const { partnerId, retailerId } = routeParams

  return instacart.go.get<SearchApiFetchDepartmentsResponse>(
    `/v1/partners/${partnerId}/warehouses/${retailerId}/departments`
  )
}
